module.exports = __webpack_public_path__ + "img/rotgear5.2197b305.gif";